/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM, createNamespace } from 'src/util/bem';
import './dataAudit.less';
import Bus, { Events } from 'src/util/bus';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import MenuBtn from 'src/pages/layout/components/menuBtn';
import alertAuditLogModal from './auditLogModal';
import DataAuditApi from './api/dataAuditApi';
import EnumAuditStatus from 'src/enums/enumAuditStatus';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import RouteUtils from 'src/util/routeUtils';
import { CommonUtil } from 'src/util/commonUtil';
import DatePicker from 'src/types/iview/DatePicker';
import Button from 'src/types/iview/Button';
import Switch from 'src/types/iview/Switch';
import EnumControlLevel from 'src/enums/enumControlLevel';
import EnumWarningNotice from 'src/enums/enumWarningNotice';
let bem = createBEM('data-audit');

@Component({ name: 'data-manage-data-audit' })
export default class DataAudit extends Vue.Component<any> {
    date = new Date();
    mn: string = '';
    name: string = '';
    statusMap = {};
    is_auto_audit: number =  EnumWarningNotice.Open.getId();
    id;
    timeout;
    // * API:获取审核日历
    async search() {
        if (!this.mn) return;
        let { code, data } = await DataAuditApi.searchAudit({
            mn: this.mn,
            start_time: DateTimeUtil.getSecondFromIviewDate((this.$refs.calendar as any).date, 'monthStart') as number,
            end_time: DateTimeUtil.getSecondFromIviewDate((this.$refs.calendar as any).date, 'monthEnd') as number,
        });
        if (code === 0) {
            let map: object = {};
            data.forEach(i => {
                map[i.data_time] = i.check_status;
            });
            this.statusMap = map;
        }
    }
    created() {
        Bus.$on(Events.StationChange, this.stationChange);
    }

    async auto_audit_status() {
        let { code, data } = await DataAuditApi.getAutoAuditStatus(this.mn);
        if (code === 0) {
            this.is_auto_audit = Number(data);
        } else {
            this.is_auto_audit = EnumWarningNotice.Open.getId();
        }
    }
    
    mounted() {
        this.mn = this.$route.query.mn;
        this.name = this.$route.query.name;
        this.is_auto_audit = this.$route.query.is_auto_audit ? +this.$route.query.is_auto_audit : EnumWarningNotice.Open.getId();
        this.id = this.$route.query.id;
        this.search();
        this.auto_audit_status();
    }
    activated() {
        this.search();
        this.auto_audit_status();
    }
    stationChange(data: StationListDOI.RowDataI) {
        this.mn = data.mn;
        this.name = data.name;
        this.id = data.id;
        this.search();
        this.auto_audit_status();
    }

    beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange);
        this.timeout = null;
    }
    dateChange() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.search(), 500);
        this.auto_audit_status();
    }

    async changeAutoAudit(open) {
        let status = open ? EnumWarningNotice.Open.getId() : EnumWarningNotice.Close.getId();
        this.is_auto_audit = status;
        DataAuditApi.changeAutoAudit(this.id, status);
    }

    render(h) {
        let t = this;
        return (
            <div class={bem()}>
                <MenuBtn class={createNamespace('mb10')} />
                <div class={bem('content')}>
                    <div class={createNamespace('mb10')} style="text-align: right">
                        自动审核:
                        <Switch
                                style="margin-left: 10px; margin-right: 10px;"
                                size="large"
                                value={this.is_auto_audit === EnumWarningNotice.Open.getId()}
                                on-on-change={this.changeAutoAudit.bind(this)}
                            >
                                <span slot="open">ON</span>
                                <span slot="close">OFF</span>
                        </Switch>
                        <DatePicker
                            on-on-change={this.search.bind(this)}
                            clearable={false}
                            v-model={this.date}
                            type="month"
                            style="width:200px;display: inline-block!important;text-align: initial;"
                        />
                        <Button class={createNamespace('ml20 mr10')} type="primary" onClick={() => alertAuditLogModal(this.mn, this.name)}>
                            审核日志
                        </Button>
                    </div>
                    <div class={bem('calendar')}>
                        <el-calendar
                            ref="calendar"
                            style="width:100%"
                            v-model={this.date}
                            on-date-change={this.search.bind(this)}
                            scopedSlots={{
                                dateCell: function(h, { date, data }) {
                                    return (
                                        <div
                                            class={bem('calender-day')}
                                            on-click={() => {
                                                if (
                                                    [
                                                        EnumAuditStatus.UnAudit.getId(),
                                                        EnumAuditStatus.PartAudit.getId(),
                                                        EnumAuditStatus.Audited.getId(),
                                                    ].includes(t.statusMap[data.day])
                                                ) {
                                                    RouteUtils.goTo('/' + t.$route.params.type + '/dataManage/dataAudit/handle', {
                                                        mn: t.mn,
                                                        date: +date,
                                                        name: t.name,
                                                        status: t.statusMap[data.day],
                                                        productId: t.$route.query.productId,
                                                        cn: t.$route.query.cn,
                                                    });
                                                }
                                            }}
                                        >
                                            <div v-if={data.type === 'current-month'}>
                                                <div class={bem('date')}>
                                                    {date.getDate()}
                                                    <span class={bem('chinese-date')}>
                                                        {DateTimeUtil.getChineseDate(date)
                                                            .split('月')
                                                            .pop()}
                                                    </span>
                                                </div>
                                                <span class={bem('status')} v-if={CommonUtil.isFieldEmpty(t.statusMap[data.day])}>
                                                    无数据
                                                </span>
                                                <span
                                                    v-else
                                                    class={bem('status', {
                                                        unchecked: t.statusMap[data.day] === EnumAuditStatus.UnAudit.getId(),
                                                        checked: t.statusMap[data.day] === EnumAuditStatus.Audited.getId(),
                                                        'part-checked': t.statusMap[data.day] === EnumAuditStatus.PartAudit.getId(),
                                                    })}
                                                >
                                                    {EnumAuditStatus.findId(t.statusMap[data.day]).getName()}
                                                </span>
                                            </div>
                                        </div>
                                    );
                                },
                            }}
                        >
                            <div slot="dateCell" />
                        </el-calendar>
                    </div>
                </div>
            </div>
        );
    }
}
